import React, { useEffect } from "react";
import "./index.scss";

import { Form, Input, Button, notification, Spin } from "antd";

import Mailing from "assets/icons/mailing.svg";
import Send from "assets/icons/send.svg";

const SubscribeForm = ({ onValidated, status, message, onClose }) => {
  const [form] = Form.useForm();

  console.log("status, message: ", status, message);

  useEffect(() => {
    if (status === "success") {
      notification.success({
        message: "Successfully!",
        description: <div dangerouslySetInnerHTML={{ __html: message }} />,
      });
      onClose();
    }
    if (status === "error") {
      notification.error({
        message: "Subscribe error",
        description: <div dangerouslySetInnerHTML={{ __html: message }} />,
      });
    }
  }, [status, message, onClose]);

  const onFinish = (values) => {
    console.log("values: ", values);
    onValidated({
      EMAIL: values.email,
      MERGE0: values.email,
    });
  };

  return (
    <div>
      <Spin spinning={status === "sending" ? true : false} tip="Loading...">
        <Form form={form} className="subscribeForm" onFinish={onFinish}>
          <div className="bannerMail">
            <div className="mailing">
              <div className="viewImage">
                <img alt="" src={Mailing} />
              </div>

              <div className="info">
                <h3>Join our mailing list!</h3>
                <p>
                  Receive updates and the latest news, straight from the Precog
                  team
                </p>

                <Form.Item
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "Email invalid",
                    },
                    {
                      required: true,
                      message: "Please input your email",
                    },
                  ]}
                >
                  <Input
                    placeholder="example@email.com"
                    type="email"
                    addonAfter={
                      <Button
                        type="primary"
                        htmlType="submit"
                        icon={<img alt="" src={Send} />}
                      />
                    }
                  />
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default SubscribeForm;
